<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">REPORTE DE TRAZABILIDAD DE ACEITE</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>    
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-card>
            <v-card-text>
                <v-row>
                    Seleccione el ´    <v-checkbox color="info" class="sin-padd" hide-details></v-checkbox>´ del bloque que desee realizar búsquedas, se habilitarán las opciones para poder usar los filtros, ingrese el/los filtro(s) ... luego haga click en buscar
                </v-row>
                <v-row>
                    <v-col cols="2" :class="`${opcion === 'planta' ? `back-${opcion}` : 'sin-back'}`">
                        <v-alert outlined color="orange">
                            <v-row>
                                <v-col cols="2">
                                    <v-checkbox v-model="opcion" value="planta" class="pt-0" color="orange" hide-details ></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <span class="text-center"><b> Producción Planta </b></span>
                                </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <label>Fecha Elaboración: </label>
                                    <date-picker :disabled="opcion !== 'planta'" v-model="produccion.fecha_prod" range-separator="|" range placeholder="Fecha Producción" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-text-field :disabled="opcion !== 'planta'" label="Folio Producción" v-model="produccion.folio_prod" ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-select
                                        :items="estanques"
                                        item-text="codigo"
                                        item-value="id"
                                        v-model="produccion.tk_prod"
                                        label="Estanque Producción"
                                        :disabled="opcion !== 'planta'"
                                        dense>
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>

                    <v-col cols="2"  :class="`${opcion === 'romana' ? `back-${opcion}` : 'sin-back'}`">
                        <v-alert outlined color="blue">
                            <v-row>
                                <v-col cols="2">
                                    <v-checkbox v-model="opcion" value="romana" class="pt-0" color="blue" hide-details ></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <span class="text-center"><b> Despachos Romana</b></span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <label>Fecha Despacho: </label>
                                    <date-picker :disabled="opcion !== 'romana'" v-model="romana.fecha_romana" range-separator="|" range placeholder="Fecha Despacho" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-text-field :disabled="opcion !== 'romana'" label="Folio Destino" v-model="romana.folio_destino" ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-text-field :disabled="opcion !== 'romana'" label="Guía Despacho" v-model="romana.guia" ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>

                    <v-col cols="2" :class="`${opcion === 'bodegas' ? `back-${opcion}` : 'sin-back'}`">
                        <v-alert outlined color="green">
                            <v-row>
                                <v-col cols="2">
                                    <v-checkbox v-model="opcion" value="bodegas" class="pt-0" color="green" hide-details ></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <span class="text-center"><b> Recepción Bodegas</b></span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-select
                                        :items="bodegas_destino"
                                        item-text="nombre"
                                        item-value="id"
                                        v-model="bodegas.bodega_destino"
                                        label="Bodega Destino"
                                        :disabled="opcion !== 'bodegas'" 
                                        dense
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-text-field :disabled="opcion !== 'bodegas'" label="Folio Abastecimiento" v-model="bodegas.folio_abast" ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-select
                                        :items="estanques_ext"
                                        label="Estanque Destino"
                                        v-model="bodegas.tk_destino"
                                        item-text="nombre_corto"
                                        item-value="id"
                                        :disabled="opcion !== 'bodegas'" 
                                        dense
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>

                    <v-col cols="2" :class="`${opcion === 'ventas' ? `back-${opcion}` : 'sin-back'}`">
                        <v-alert outlined color="gray">
                            <v-row>
                                <v-col cols="2">
                                    <v-checkbox v-model="opcion" value="ventas" class="pt-0" color="gray" hide-details ></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <span class="text-center"><b> Exportación / Venta</b></span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <label>Fecha Embarque: </label>
                                    <date-picker :disabled="opcion !== 'ventas'" v-model="ventas.fecha_embarque" range-separator="|" range placeholder="Fecha Embarque" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-text-field :disabled="opcion !== 'ventas'" label="Número Embarque" v-model="ventas.embarque" ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <v-text-field :disabled="opcion !== 'ventas'" label="Guía Embarque" v-model="ventas.guia_vta" ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>

                    <v-col cols="3">
                        <v-row>
                            <v-col cols="12" v-if="(opcion == 'planta') || opcion == 'bodegas'">
                                <v-checkbox 
                                            v-model="solo_stock" 
                                            label="Traer solo stocks positivos" 
                                            class="pt-0 mb-6" 
                                            color="blue" 
                                            hide-details 
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" v-if="(opcion == 'romana') || opcion == 'ventas'">
                            </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-btn dark color="blue darken-1" class="mb-4" @click="cargar_traza"><v-icon>search</v-icon> Buscar</v-btn>
                        </v-row>
                        
                        <pre class="mb-4">filtro {{this.opcion}}</pre>
                        
                        <v-row>
                            <span>Exportar Excel</span>
                        </v-row>
                        <v-row>
                            <v-btn dark color="green darken-1" :disabled="url_excel == ''" @click="exportarExcel"><v-icon>file_download</v-icon> Excel</v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <div class="table-wrap">
                <v-simple-table
                    fixed-header
                    width="100%"
                    height="90vh"
                >
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-center cabecera" colspan="8"> Producciones </th>
                            <th class="text-center cabecera" colspan="6"> Despachos - Mermas </th>
                            <th class="text-center cabecera" colspan="7"> Recepciones </th>
                            <th class="text-center cabecera" colspan="20"> Exportaciones - Ventas </th>

                        </tr>
                        <tr>
                            <th class="text-center cabecera">
                                Fecha Elaboración
                            </th>
                            <th class="text-center cabecera">
                                Folio Producción
                            </th>
                            <th class="text-center cabecera">
                                Cantidad
                            </th>
                             <th class="text-center cabecera">
                                Stock
                            </th>
                            <th class="text-center cabecera">
                                Línea
                            </th>
                            <th class="text-center cabecera m200" >
                                Proceso
                            </th>
                            <th class="text-center cabecera">
                                Estanque
                            </th>
                            <th class="text-center cabecera">
                                Observación
                            </th>
                            <th class="text-center cabecera">
                                Fecha Despacho
                            </th>
                            <th class="text-center cabecera">
                                Guía Despacho
                            </th>
                            <th class="text-center cabecera">
                                Ticket
                            </th>
                            <th class="text-center cabecera">
                                Folio Destino
                            </th>
                            <th class="text-center cabecera m160">
                                Lugar Destino
                            </th>
                            <th class="text-center cabecera">
                                Cant. Despacho
                            </th>
                            <th class="text-center cabecera">
                                Fecha Abastecim.
                            </th>
                            <th class="text-center cabecera">
                                Folio Abastecim.
                            </th>
                            <th class="text-center cabecera">
                                Estanque Destino
                            </th>
                            <th class="text-center cabecera m140">
                                Lote Destino
                            </th>
                            <th class="text-center cabecera">
                                Cant. Recepción
                            </th>
                            <th class="text-center cabecera">
                                Stock
                            </th>
                            <th class="text-center cabecera">
                                Observación
                            </th>
                            <th class="text-center cabecera">
                                Fecha Embarque
                            </th>
                            <th class="text-center cabecera">
                                Nro. Embarque
                            </th>
                            <th class="text-center cabecera">
                                Guía Embarque
                            </th>
                            <th class="text-center cabecera">
                                Cant. Embarque
                            </th>
                            <th class="text-center cabecera">
                                Bodega Destino
                            </th>
                            <th v-for="item in cabeceras" :key="item.id" class="text-center cabecera">
                                {{item.documento}}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-html="filitas">

                    </tbody>
                </template>
                </v-simple-table>
            </div>
            <modal-comentar-traza></modal-comentar-traza>
        </v-card>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import DatePicker from 'vue2-datepicker';
import Modal_Comentar_Traza from '@/components/shared/Modal_Comentar_Traza.vue';

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from "../../components/shared/ModalAyudas.vue";
export default {
    data:() => ({
        opcion:'planta',
        solo_stock:false,
        produccion:{
            fecha_prod:'',
            folio_prod:'',
            tk_prod:'',
        },
        romana:{
            fecha_romana:'',
            folio_destino:'',
            guia_desp:'',
        },
        bodegas:{
            bodega_destino:'',
            folio_abast:'',
            tk_destino:'',
        },
        ventas:{
            fecha_embarque:'',
            embarque:'',
            guia_vta:'',
        },
        datos: [],
        estanques_ext:[],
        bodegas_destino: [],
        estanques:[],
        cabeceras:[],
        url:'',
        url_excel: ''
    }),
    mounted(){
        this.fecha =  this.moment().format('YYYY-MM-DD');
        this.cargarBodegas();
        this.cargarEstanquesExternos();
        this.cargarEstanques();
    },
    methods:{
        async cargarBodegas(){
            this.mostrarLoading({titulo:'Cargando bodegas...',color:'green'})
            let url = `${this.base_url}bodegas?tipo_produccion_id=2`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas_destino = res.data.data;
                this.bodegas_destino.unshift({id:'', nombre:''})
                this.ocultarLoading();
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar bodegas ");
                console.log('error',error);
            });
        },
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte de Trazabilidad de Aceite`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra todo el flujo de la trazabilidad del aceite según el filtro y las opciones seleccionadas`},
                {   tipo:`label`,   texto:`- Se selecciona el bloque que se desee para filtrar la trazabilidad y las opciones de cada uno`},
                {   tipo:`label`,   texto:`- Opcionalmente, se puede seleccionar la opción de buscar solo por estanques con stock positivo mediante recuadro de la derecha (para filtro de Producción Planta y Recepción Bodegas).`},
                {   tipo:`label`,   texto:`- Para finalmente realizar la búsqueda, se debe pulsar botón "Buscar"`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarEstanquesExternos(){
            this.mostrarLoading({titulo:'Cargando estanques externos...',color:'green'})
            let url = `${this.base_url}estanques_externos/0`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.estanques_ext = res.data.data;
                this.estanques_ext.unshift({id:'', nombre_corto:''})
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.errorMessage(error, "Error al cargar estanques externos ");
            });
        },
        async cargarEstanques(){
            let url = `${this.base_url}estanque_aceites`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.estanques = response.data.data;
                this.estanques.unshift({id:'', codigo:''})
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar estanques ");
            });
        },
        async cargar_traza(){
            this.mostrarLoading({titulo:'Buscando Información...',color:'green'});
            let body = {}
            if (this.opcion == 'planta') {
                body = this.produccion
            } else if (this.opcion == 'romana') {
                body = this.romana
            } else if (this.opcion == 'bodegas') {
                body = this.bodegas
            } else if (this.opcion == 'ventas') {
                body = this.ventas
            }
            if (this.solo_stock) {
                body.solo_stock = 1
            } else {
                body.solo_stock = 0
            }
            body.opcion = this.opcion
            console.log("body", body);
            // let fecha_ini = this.fecha[0];
            // let fecha_fin = this.fecha[1];
            let url = `${this.base_url}reporte_aceites`;
            await this.axios.post(url, body, this.headers).then((res) =>{
                this.datos = res.data.info;
                this.cabeceras = res.data.mov_docs;
                this.url_excel = res.data.url_excel;
            }).catch((e)=>{
                console.log(e);
            });
            this.ocultarLoading();
        },

        exportarExcel(){
            console.log('url_excel',this.url_excel);
            let url = this.download_url.replace('bitacoras', 'formatos/aceites/') 
            window.location.href = url + this.url_excel;
        },
        async grabar_incremento(d, f){
            let url = `${this.base_url}despachos_harina/grabar/incremento`;
            if(typeof d[f] == "boolean") d[f] = d[f] == true ? 1:0;
            let body = {
                despacho_pts_id: d.id,
                incremento: d.incremento,
                campo: f,
                valor: d[f]
            }
            await this.axios.post(url, body, this.headers).then((res)=>{
                console.log(res.data.data);
            }).catch((e)=>{
                console.log(e);
            });
        },
        abrirModalComentario(registro){
            console.log('registro', registro);
            Event.$emit('abrir_modal_comentar_traza',registro);
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        filitas(){
            let filitas = "";
            //let arr = [];
            let clase = "";
            let fp = "";
            let fd = "";
            let fr = "";
            let fv = "";
            let mov_doc = '';
            this.datos.forEach( (fila,idx) => {
                //console.log("filita " + idx, fila )

                clase = "";
                if((idx % 2) == 0){
                    clase = "cebrita";
                }

                fp = `  <td rowspan="${fila.filas_d}" class="${clase} centrado td2">${fila.fecha}</td>
                        <td rowspan="${fila.filas_d}" class="${clase} centrado">${fila.folio_prod || ''}</td>
                        <td rowspan="${fila.filas_d}" class="${clase} centrado">${fila.produccion}</td>
                        <td rowspan="${fila.filas_d}" class="${clase} centrado">${fila.stock}</td>
                        <td rowspan="${fila.filas_d}" class="${clase} centrado">${fila.linea}</td>
                        <td rowspan="${fila.filas_d}" class="${clase} centrado m120">${fila.tipo_mp}</td>
                        <td rowspan="${fila.filas_d}" class="${clase} centrado">${fila.estanque}</td>
                        <td rowspan="${fila.filas_d}" class="${clase} centrado">${fila.obs_aceite || ''}</td>`;
                
                fila.despachos.forEach((desp,d) => {
                    fd = `  <td rowspan="${desp.filas_r}" class="${clase} centrado td2">${desp.fecha_desp}</td>
                            <td rowspan="${desp.filas_r}" class="${clase} centrado">${desp.guia_desp}</td>
                            <td rowspan="${desp.filas_r}" class="${clase} centrado">${desp.ticket || ''}</td>
                            <td rowspan="${desp.filas_r}" class="${clase} centrado">${desp.folio_destino || ''}</td>
                            <td rowspan="${desp.filas_r}" class="${clase} centrado">${desp.bodega_desp || ''}</td>
                            <td rowspan="${desp.filas_r}" class="${clase} centrado">${desp.cantidad}</td>`;
                    if(d > 0){ fp = ""; }

                    desp.recepciones.forEach((rec,r) => {
                        fr = `  <td rowspan="${rec.filas_v}" class="${clase} centrado td2">${rec.fecha_rec}</td>
                                <td rowspan="${rec.filas_v}" class="${clase} centrado">${rec.folio_abastecimiento || ''}</td>
                                <td rowspan="${rec.filas_v}" class="${clase} centrado">${rec.tk_e}</td>
                                <td rowspan="${rec.filas_v}" class="${clase} centrado">${rec.lote_e || ''}</td>
                                <td rowspan="${rec.filas_v}" class="${clase} centrado">${rec.litros}</td>
                                <td rowspan="${rec.filas_v}" class="${clase} centrado">${rec.stock_b}</td>
                                <td rowspan="${rec.filas_v}" class="${clase} centrado">${rec.observacion || ''}</td>`;
                        if(r > 0){ fp = ""; fd = ""; }

                        rec.ventas.forEach((vta,v) => {
                            fv = `  <td class="${clase} centrado td2">${vta.fecha_vta}</td>
                                    <td class="${clase} centrado">${vta.nro_embarque}</td>
                                    <td class="${clase} centrado">${vta.guia_vta || ''}</td>
                                    <td class="${clase} centrado">${vta.cant_vta}</td>
                                    <td class="${clase} centrado">${vta.bodega_vta || ''}</td>`;
                            if(v > 0){ fp = ""; fd = ""; fr = ""; }
                            this.cabeceras.forEach(row => {
                                mov_doc = vta[row.id]
                                if (mov_doc) {
                                    fv += ` <td class="${clase} centrado">${mov_doc}</td>`;
                                } else {
                                    fv += ` <td class="${clase} centrado"></td>`;
                                }
                            })

                            filitas += `<tr>${fp}${fd}${fr}${fv}</tr>`;
                        });
                    });
                });
            });
            return filitas;
        },
        ...mapState(['base_url', 'user', 'headers', 'download_url']),
    },
    components:{
        DatePicker,
        'modal-comentar-traza':Modal_Comentar_Traza,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    td{padding: 0em 1em; border-bottom:1px solid #01579B !important;}
    .td2{border-left:1px solid #01579B !important;}
    .fila_r{background-color: #b2dfdb;}
    .table-wrap {width: 100%;  overflow-x: auto;  }
    .tablet>thead>tr>th {background-color: white; position: sticky; position: -webkit-sticky; top: 0; z-index: 2;} 
    .mx-datepicker{width: 100%!important;}
    .cebrita{background-color: #c5d1d7f0 !important;}
    .centrado{text-align:center !important; vertical-align:middle !important;}
    .v-data-table td { font-size: 0.875rem; height: 30px; }
    .m100{min-width: 100px!important;} .m120{min-width: 120px!important;} .m140{min-width: 140px!important;} .m160{min-width: 160px!important;} .m180{min-width: 180px!important;} .m200{min-width: 200px!important;}
    .back-planta{background-color:#FFF3E0;}
    .back-romana{background-color: #E1F5FE;}
    .back-bodegas{background-color: #E8F5E9;}
    .back-ventas{background-color: #F5F5F5;}
    .sin-back{background-color: transparent}
    .sin-padd{
        margin: 0 -8px 0 0 !important;
        padding: 0 !important;
    }
</style>
